import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Black The Gazette</p>
        <h1>Discover the Pulse of Your Community</h1>
        <p className="lede">
          Stay informed with the latest news, events, and stories that matter to you. Black The Gazette is your go-to source for engaging content that reflects the vibrant culture and spirit of our community.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Explore Latest News
          </a>
          <a href="/subscribe" target="_self" className="secondary">
            Subscribe Now
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Stay Updated</h2>
          <p>
            Get real-time updates on local happenings, community events, and important announcements delivered straight to your inbox.
          </p>
        </article>
        <article>
          <h2>Engage with Us</h2>
          <p>
            Join the conversation! Share your thoughts, stories, and experiences with our community through comments and social media.
          </p>
        </article>
        <article>
          <h2>Celebrate Diversity</h2>
          <p>
            Explore a rich tapestry of culture, art, and history that showcases the unique contributions of our community members.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;